import moment from "moment";

export const rangoDePeriodo = (periodo, diaSuelto) => {
    const hoy = moment();
    switch (periodo) {
        case "ayer":
            return { from: moment().subtract(1, "day"), to: moment().subtract(1, "day") };
        case "semana":
            return { from: moment().startOf("isoWeek"), to: hoy };
        case "semanaPasada":
            return {
                from: moment().subtract(1, "week").startOf("isoWeek"),
                to: moment().subtract(1, "week").endOf("isoWeek")
            };
        case "semanaYPasada":
            return { from: moment().subtract(1, "week").startOf("isoWeek"), to: hoy };
        case "mes":
            return { from: moment().startOf("month"), to: hoy };
        case "mesPasado":
            return {
                from: moment().subtract(1, "month").startOf("month"),
                to: moment().subtract(1, "month").endOf("month")
            };
        case "tresMeses":
            return { from: moment().subtract(3, "month"), to: hoy };
        case "dia":
            return { from: moment(diaSuelto), to: moment(diaSuelto) };

        case "hoyAyer":
        case "hoy":
        default:
            return { from: hoy, to: hoy };
    }
};
